import { Component, computed, input } from '@angular/core';

import { CellOverlayAction } from '@shared/components/table/table-cell/actions-overlay/actions-overlay.component';
import {
  DurationSegment,
  formatCellValue,
  processDurationValue,
  splitDurationParts
} from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-duration-cell',
  imports: [],
  templateUrl: './duration-cell.component.html'
})
export class DurationCellComponent {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'duration');

  value = input<unknown | undefined>(undefined);

  protected segments = computed<DurationSegment[]>(() =>
    splitDurationParts(processDurationValue(this.value()))
  );
}
